<template>
<DashboardPanelTemplate :panelSize="panelSize" :panelFocus="panelFocus" :loading="loading">
  <h4>{{$t('Header')}}</h4>
  <p>{{$t('Content1')}}</p>
  <p>{{$t('Content2')}}</p>
  <div class="welcome-panel-end-fill">
    <div class="welcome-panel-end-fill-content">
      <div class="row w-100">
        <div class="col dhruv-wrapper">
          <div class="dhruv">
            <p class="name">{{$t('DhruvName')}}</p>
            <p class="title">{{$t('DhruvTitle')}}</p>
          </div>
        </div>
        <div class="col suggestion-wrapper">
          <span class="suggestion-text">
            <a id="suggestion" href="" onclick="return false">{{$t('Suggestion')}}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</DashboardPanelTemplate>
</template>
<script>
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
export default {
  name: 'WelcomePanel',
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DashboardPanelTemplate
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Welcome back!',
        Content1: `You're using a beta version of our new Merchant Dashboard.`,
        Content2: `The goal is to provide useful information and links so you can dive further into what's driving your ecommerce
          business with ShipBob. Let us know what you think.`,
        Suggestion: 'Question or suggestion - let us know',
        DhruvName: 'Dhruv Saxena',
        DhruvTitle: 'Co-Founder & CEO'
      }
    }
  }
}

</script>
<style scoped lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_setup-panel-welcome.scss';
</style>